import { ReportTemplateApplyColumn } from "@common/types/views/reportTemplateApplyView";
import { View, ViewDensity, ViewType } from "@common/types/views/views";
import { ViewConfig } from "@lib/views";
import type { ApplyReportTemplateRow } from "./applyReportTemplateRows";
import { ApplyReportTemplateNameCell } from "./cells/ApplyReportTemplateNameCell";
import { ApplyReportTemplateOverridesCell } from "./cells/ApplyReportTemplateOverridesCell";
import { ApplyReportTemplateTemplateCell } from "./cells/ApplyReportTemplateTemplateCell";

export const applyReportTemplateViewConfig: ViewConfig<
    ApplyReportTemplateRow,
    ReportTemplateApplyColumn,
    never
> = {
    columns: {
        [ReportTemplateApplyColumn.NAME]: {
            accessorKey: "name",
            name: "Client",
            header: "Client",
            cell: ApplyReportTemplateNameCell,
            immutable: true,
            minSize: 260,
            maxSize: 480,
        },
        [ReportTemplateApplyColumn.CURRENT_TEMPLATE]: {
            accessorKey: "currentTemplate",
            name: "Current template",
            header: "Current template",
            cell: ApplyReportTemplateTemplateCell,
            minSize: 220,
            maxSize: 480,
        },
        [ReportTemplateApplyColumn.NEW_TEMPLATE]: {
            accessorKey: "newTemplate",
            name: "New template",
            header: "New template",
            cell: ApplyReportTemplateTemplateCell,
            minSize: 220,
            maxSize: 480,
        },
        [ReportTemplateApplyColumn.OVERRIDES]: {
            accessorKey: "overrideCount",
            name: "Overrides",
            header: "Overrides",
            cell: ApplyReportTemplateOverridesCell,
            minSize: 140,
            maxSize: 240,
        },
    },
    nesting: {
        enabled: true,
        expandColumn: ReportTemplateApplyColumn.NAME,
        childrenKey: "children",
    },
};

export const defaultApplyReportTemplateView: View = {
    type: ViewType.REPORT_TEMPLATE_APPLY,
    columns: [
        { id: ReportTemplateApplyColumn.NAME, options: { pin: "left" } },
        { id: ReportTemplateApplyColumn.CURRENT_TEMPLATE },
        { id: ReportTemplateApplyColumn.NEW_TEMPLATE },
        { id: ReportTemplateApplyColumn.OVERRIDES },
    ],
    filters: {},
    options: {
        bulkActions: true,
        alwaysShowSelection: true,
        hideSelectAll: true,
        density: ViewDensity.MD,
    },
};
